module.exports = __webpack_public_path__ + "images/index/TDRI_06.085a97d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proimg/tdri/TDRI_06.jpg
// module id = 5vfP
// module chunks = 21